<template>
    <div class="row">
        <div class="form-group col-6">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="supplier.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>

        <div class="form-group col-6">
            <label for="email">Email (Daily and Monthly Reports)</label>
            <input
                id="email"
                v-model="supplier.email"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('email')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('email') }}
            </div>
        </div>

        <div class="form-group col-6">
            <label for="emailTime">Sending the daily summary email time</label>
            <input
                id="emailTime"
                v-model="supplier.emailTime"
                type="time"
                class="form-control"
            />
            <small>Depends on your time zone</small>
        </div>

        <div class="form-group col-6">
            <label for="secondEmail">
                Second email (Daily and Monthly Reports)
            </label>
            <input
                id="secondEmail"
                v-model="supplier.secondEmail"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('secondEmail')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('secondEmail') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            supplier: {}
        };
    },

    watch: {
        supplier() {
            this.$emit('input', this.supplier);
        }
    },

    created() {
        this.supplier = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.supplier[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.supplier,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
